<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="Master Device">
      <!-- <b-card-text>Device.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Category -->
            <b-col cols="12">
              <b-form-group label="Category" label-for="v-Category">
                <validation-provider #default="{ errors }"  name="Category" rules="required">
                  <v-select id="v-Category" v-model="form.select_1" placeholder="Chose  Category" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="CategoryOptions" :reduce="CategoryOptions => CategoryOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Question -->
            <b-col cols="12">
              <b-form-group label="Question" label-for="v-Question">
                <validation-provider #default="{ errors }"  name="Question" rules="required">
                  <b-form-input  id="v-Question" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Question" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Answer -->
            <b-col cols="12">
              <b-form-group label="Answer" label-for="v-Answer">
                <validation-provider #default="{ errors }"  name="Answer" rules="required">
                  <b-form-textarea  id="v-Answer" :state="errors.length > 0 ? false:null" v-model="form.textarea_1" placeholder="Answer" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BCol, BFormGroup, BFormCheckbox, BFormTextarea,  BFormInput, BForm, BButton, BCard,  BImg} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BFormCheckbox, BFormTextarea,  ValidationProvider, ValidationObserver, BCard, BImg, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, select_1: '', text_1: '', textarea_1: '', imageUrl: require('@/assets/images/icons/jpg.png'), setImage: 'none', logo: null},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ CategoryOptions: state => state.faq.category.options})
  },
  created () {
    this.$store.dispatch('faq/getCategory')
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('faq/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('faq/getById', id).then(data => {
        this.form.id = data.id
        this.form.select_1 = data.faq_category_id
        this.form.text_1 = data.question
        this.form.textarea_1 = data.answer
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>